import { render, staticRenderFns } from "./NFTinfo.vue?vue&type=template&id=244ff81a&scoped=true"
import script from "./NFTinfo.vue?vue&type=script&lang=js"
export * from "./NFTinfo.vue?vue&type=script&lang=js"
import style0 from "./NFTinfo.vue?vue&type=style&index=0&id=244ff81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ff81a",
  null
  
)

export default component.exports